// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"9634bacb","315":"bfa90751","361":"22262497","362":"0a91695a","776":"4273f83b","844":"61c9029f"}[chunkId] + ".css";
};